/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Collection,
  ListCollectionsParams,
  ListFeaturedCollectionsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary List of Collections
 */
export const listCollections = (
    params?: MaybeRefOrGetter<ListCollectionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Collection[]>(
      {url: `/collections`, method: 'GET',
        params, signal
    },
      );
    }




export const getListCollectionsQueryKey = (params?: MaybeRefOrGetter<ListCollectionsParams>,) => {
    return [
    'collections', ...(params ? [params] : [])
    ] as const;
    }


export const getListCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listCollections>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListCollectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCollections>>> = ({ signal }) => listCollections(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCollections>>, TError, TData>
}

export type ListCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listCollections>>>
export type ListCollectionsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of Collections
 */

export function useListCollections<TData = Awaited<ReturnType<typeof listCollections>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCollections>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List of featured Collections
 */
export const listFeaturedCollections = (
    params?: MaybeRefOrGetter<ListFeaturedCollectionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Collection[]>(
      {url: `/collections/featured`, method: 'GET',
        params, signal
    },
      );
    }




export const getListFeaturedCollectionsQueryKey = (params?: MaybeRefOrGetter<ListFeaturedCollectionsParams>,) => {
    return [
    'collections','featured', ...(params ? [params] : [])
    ] as const;
    }


export const getListFeaturedCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listFeaturedCollections>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ListFeaturedCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListFeaturedCollectionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFeaturedCollections>>> = ({ signal }) => listFeaturedCollections(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCollections>>, TError, TData>
}

export type ListFeaturedCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listFeaturedCollections>>>
export type ListFeaturedCollectionsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of featured Collections
 */

export function useListFeaturedCollections<TData = Awaited<ReturnType<typeof listFeaturedCollections>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ListFeaturedCollectionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFeaturedCollections>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListFeaturedCollectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Collection Details
 */
export const getCollection = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Collection>(
      {url: `/collections/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetCollectionQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'collections',id
    ] as const;
    }


export const getGetCollectionQueryOptions = <TData = Awaited<ReturnType<typeof getCollection>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetCollectionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollection>>> = ({ signal }) => getCollection(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>
}

export type GetCollectionQueryResult = NonNullable<Awaited<ReturnType<typeof getCollection>>>
export type GetCollectionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Collection Details
 */

export function useGetCollection<TData = Awaited<ReturnType<typeof getCollection>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollection>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List of recommended Collections
 */
export const listRecommendedCollections = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Collection[]>(
      {url: `/collections/${id}/recommendations`, method: 'GET', signal
    },
      );
    }




export const getListRecommendedCollectionsQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'collections',id,'recommendations'
    ] as const;
    }


export const getListRecommendedCollectionsQueryOptions = <TData = Awaited<ReturnType<typeof listRecommendedCollections>>, TError = ErrorType<SchemaValidationErrorResponse>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecommendedCollections>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListRecommendedCollectionsQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecommendedCollections>>> = ({ signal }) => listRecommendedCollections(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecommendedCollections>>, TError, TData>
}

export type ListRecommendedCollectionsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecommendedCollections>>>
export type ListRecommendedCollectionsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary List of recommended Collections
 */

export function useListRecommendedCollections<TData = Awaited<ReturnType<typeof listRecommendedCollections>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecommendedCollections>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecommendedCollectionsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






